import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { ValueDescription } from '../../../value-description/value-description';
import { useRootStore } from '../../../../../../providers/root-store-provider';
import { CardDashboardTradesLoading } from '../card-loading/card-dashboard-trades-loading';
import { ValueAmount } from '../../../../value/amount/value-amount';
import { CardTitle } from '../../../title/card-title';
import { ValuePercents } from '../../../../value/percents/value-precents';

export const CardDashboardTradesRealizedProfit: React.FC = observer(() => {
    const { t } = useTranslation();

    const rootStore = useRootStore();
    const { portfolioStore, statisticStore } = rootStore;
    const { overviewStore } = statisticStore;
    const { overview } = overviewStore;

    const portfolioCurrency = portfolioStore.selectedPortfolio.portfolioHistoryCurrencyCode;

    return (
        <CardDashboardTradesLoading fields={['realizedProfit']}>
            <div className="relative flex h-full flex-col items-stretch justify-between overflow-hidden rounded-large bg-surface p-[1.6rem] shadow-strong lg:p-[2.2rem]">
                <CardTitle
                    title={t('layout.statisticsCard.realizedProfit.title')}
                    tooltip={t('layout.statisticsCard.realizedProfit.tooltip')}
                />
                {overview && (
                    <ValueDescription
                        value={
                            <ValueAmount
                                amount={overview.realizedProfit}
                                currency={portfolioCurrency}
                                mode="pure"
                                nullValue={0}
                                hidable
                            />
                        }
                        valueColor={overview.realizedProfit > 0 ? 'positive' : 'negative'}
                        padding={'none'}
                        description={
                            <Trans
                                i18nKey="layout.statisticsCard.realizedProfit.ofPortfolioValue"
                                components={{
                                    value: <ValuePercents amount={overview.realizedProfitPercentage} mode="pure" />,
                                }}
                            />
                        }
                    />
                )}
            </div>
        </CardDashboardTradesLoading>
    );
});
